export const QUERY_PARAMS = {
  GENIUS_FAST_CHECKOUT: 'geniusFastCheckout',
  GENIUS_TRIAL_3M: 'geniusTrial3M',
  GENIUS_TRIAL_3M_FAST_CHECKOUT: 'geniusTrial3MFastCheckout',
  CHECKOUT_VOUCHER_APPLIED_NOTIFICATION: 'voucherApplied',
  MEAL_VOUCHER_CODE: 'code',
  MEAL_VOUCHER_SUCCESS: 'success',
  MEAL_VOUCHER_ERROR: 'error',
} as const;
